const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFavicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 57 49",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M29.818,26.213l-2.336,11.071c-0.032,0.15 -0.164,0.257 -0.317,0.257l-4.417,0c-0.097,0 -0.19,-0.044 -0.251,-0.12c-0.062,-0.076 -0.086,-0.176 -0.065,-0.271c-0,-0 4.728,-22.188 4.728,-22.187c1.957,-9.365 7.839,-14.963 17.257,-14.963c3.943,0 6.951,1.17 8.976,3.055c2.04,1.899 3.091,4.528 3.091,7.454c0,3.76 -1.493,8.668 -6.013,11.993c-2.992,2.2 -7.317,3.711 -13.433,3.711l-7.22,0Zm0.917,-4.441l7.862,0c9.863,0 12.822,-6.745 12.822,-10.64c0,-1.83 -0.625,-3.49 -1.881,-4.689c-1.267,-1.212 -3.17,-1.95 -5.693,-1.95c-6.838,0 -10.521,5.082 -11.686,10.603l-1.424,6.676Z",
    style: {
      fill: "#0aa8bc",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.789,22.195c0.074,-0.329 -0.109,-0.423 -0.365,-0.423c-1.223,0 -3,0 -3,0c-6.1,0 -10.45,1.607 -13.434,3.801c-4.503,3.312 -5.99,8.202 -5.99,11.948c-0,2.91 0.929,5.055 2.571,6.84c1.61,1.752 4.132,3.753 10.515,3.753c3.779,-0 7.141,-1.483 9.089,-2.795c2.437,-1.642 3.589,-3.148 4.411,-4.585c0.114,-0.199 0.02,-0.431 -0.228,-0.431l-4.848,0c-0.371,0 -0.476,0.053 -0.641,0.186c-0.126,0.101 -0.695,0.666 -1.445,1.213c-1.656,1.208 -2.95,1.975 -6.338,1.975c-3.359,-0 -4.959,-0.829 -6.236,-2.049c-1.266,-1.21 -1.898,-2.884 -1.898,-4.73c-0,-3.913 2.969,-10.697 12.879,-10.697l3.679,0c0.233,0 0.441,-0.148 0.483,-0.328c0.155,-0.671 0.641,-2.984 0.796,-3.678Z",
    style: {
      fill: "#92d2dc"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavicon);
export default __webpack_public_path__ + "static/media/favicon.bf8e5063ef958503a9a026e69aeb92c4.svg";
export { ForwardRef as ReactComponent };